import React from 'react';
import { Provider } from 'react-redux';
import store from '../../../state';
import DutyTransactionCandidateStatus from './DutyTransactionCandidateStatus';

const DutyTransactionCandidateStatusStandAlone = props => (
  <Provider store={store}>
    <DutyTransactionCandidateStatus {...props} />
  </Provider>
);

export default DutyTransactionCandidateStatusStandAlone;
